if (!customElements.get('gray-instagram')) {
  customElements.define(
    'gray-instagram',
    class extends HTMLElement {
      connectedCallback() {
        this.prepareFeed = () => {
          this.querySelectorAll('.instafeed-new-layout-container[data-layout="6"]').forEach((feed) => {
            // The app prevents native swipes even in grid mode. Restore scrolling
            // for this section without changing its post links or popup handlers.
            feed.setAttribute('data-instafeed-prevent-touch-scroll', 'false');
            feed.setAttribute('tabindex', '0');
            feed.setAttribute('role', 'region');
            feed.setAttribute('aria-label', this.dataset.label);
          });
        };

        document.addEventListener('instafeedAppLoaded', this.prepareFeed);
        this.prepareFeed();
      }

      disconnectedCallback() {
        document.removeEventListener('instafeedAppLoaded', this.prepareFeed);
      }
    }
  );
}
